import type { SettingsResponse, SecretStatus } from "../api/settings";

const DOMAIN_ORDER = ["Video", "Voice-LiveKit", "Auth", "Email", "Recording", "Worker", "Platform"];

export interface SettingsGroup {
  domain: string;
  config: SettingsResponse["config"];
  secrets: SettingsResponse["secrets"];
}

export function settingsGroups(snap: SettingsResponse): SettingsGroup[] {
  const domains = new Set<string>([
    ...snap.config.map((c) => c.domain),
    ...snap.secrets.map((s) => s.domain),
  ]);
  const ordered = [...domains].sort((a, b) => {
    const ia = DOMAIN_ORDER.indexOf(a);
    const ib = DOMAIN_ORDER.indexOf(b);
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
  });
  return ordered
    .map((domain) => ({
      domain,
      config: snap.config.filter((c) => c.domain === domain),
      secrets: snap.secrets.filter((s) => s.domain === domain),
    }))
    .filter((g) => g.config.length + g.secrets.length > 0);
}

export function secretStatusLabel(s: Pick<SecretStatus, "configured" | "last_rotated">): string {
  if (s.configured === null) return "Status unknown (IAM pending)";
  if (!s.configured) return "Missing";
  return s.last_rotated ? `Configured · rotated ${s.last_rotated.slice(0, 10)}` : "Configured";
}
